import { FieldValidator } from './field-validator';
import { PoleNumberValidator } from './pole-number.validator';

export const SCRIPT_VALIDATORS: Record<string, FieldValidator> = {
  poleNumber: new PoleNumberValidator()
};
